import {Component, Inject} from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { LoopBackAuth } from "../../sdk/services/core";
import { OpenErpServiceApi } from "../../sdk/services";
import { SDKToken } from "../../sdk/models";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServerProvider } from '../../providers/server-provider';
import { LoadingComponent } from '../../components/loadingComponent';
import {EnvVariables} from "../../../envioronment-variables/environment-variables.token";
import {MyApp} from "../../app/app.component";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
    segment: 'login',
    name: 'LoginPage'
})
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
})
export class LoginPage {

    public formGroupLogin: FormGroup;
    submitAttempt: boolean = false;
    public loginHosts: any[];

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public openErpService: OpenErpServiceApi,
        public authService: LoopBackAuth,
        public alertCtrl: AlertController,
        public formBuilder: FormBuilder,
        private loading: LoadingComponent,
        private myApp: MyApp,
        @Inject(EnvVariables) public envVariables
    ) {

        // Hosts
        this.loginHosts = this.envVariables.hosts;

        this.myApp.getDefaultHostId().then(hostId => {
            //validacion del formulario
            this.formGroupLogin = formBuilder.group({
                username: ['', Validators.required],
                password: ['', Validators.required],
                hostId: [hostId, Validators.required]
            });
        });

    }

    public ionViewDidLoad() {
        // load the initial list

        if (this.authService && this.authService.getAccessTokenId() && this.authService.getCurrentUserData()){
            //estamos logueados, ir a la pagina de inicio
            this.navCtrl.setRoot('FaqPage');
        }
    }

    /**
     * boton de login
     */
    public login() {

        this.submitAttempt = true;

        if (this.formGroupLogin.valid) {
            //datos del formulario validos, hacer login

            //abrir modal
            this.loading.create({content: 'Entrando', showBackdrop: false});

            //Nombre de usuario en minuscula siempre
            let username:string = this.formGroupLogin.controls.username.value.toLowerCase();

            // nombre del host al que se realiza el login
            ServerProvider.myApp.setHostId(this.formGroupLogin.controls.hostId.value);

            //login
            this.openErpService
                .login(username, this.formGroupLogin.controls.password.value, ServerProvider.myApp.getHostId(), ServerProvider.getCustomHeaders)
                .subscribe((token: SDKToken) => {
                    //login correcto

                    //guardar datos de usuario
                    this.authService.setToken(token);
                    this.authService.setUser({ name: username });
                    this.authService.setRememberMe(true);
                    this.authService.save();

                    //obtener datos del usuario
                    ServerProvider.myApp.getLoadMyUser();

                    //ocultar loading modal
                    this.loading.dismiss();

                    //redirigir a la pagina princial
                    this.navCtrl.setRoot('FaqPage');


                });

        } else {
            //datos del formulario no validos
            this.alertCtrl.create({ title: 'Error', subTitle: 'Nombre de usuario o contraseñas no pueden estar vacíos', buttons: ['Aceptar'] }).present();
        }
    }

    public onChangeHostId(event) {
        if (event != null) {
            this.myApp.setHostId(event);
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts